import SerialNumberActivityLogPanel from './serialNumberActivityLogPanel.container';

export default SerialNumberActivityLogPanel